import { render } from "./TableWebsiteRegistered.vue?vue&type=template&id=36f82c3d&scoped=true"
import script from "./TableWebsiteRegistered.vue?vue&type=script&lang=js"
export * from "./TableWebsiteRegistered.vue?vue&type=script&lang=js"

import "./TableWebsiteRegistered.vue?vue&type=style&index=0&id=36f82c3d&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-36f82c3d"

export default script